import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M4 4h11.429v11.429H4zm12.571 0H28v11.429H16.571zM4 16.571h11.429V28H4zm12.571 0H28V28H16.571z"
    }
  )
);
var SvgWindowsFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var WindowsFilled_default = SvgWindowsFilled;

export { WindowsFilled_default as default };
